import { getNavIcon } from '../visual-elements';
import { getAppSwitcherDomTarget } from './get-app-switcher-dom-target';
export const injectNavigationMenuItem = (options, handler) => {
    const domNodeTarget = getAppSwitcherDomTarget(options.targetId);
    if (!domNodeTarget) {
        return;
    }
    domNodeTarget.prepend(getNavIcon(options, handler));
};
